import { UI, HStack, Stack, VStack } from '@genial/components';
import { BoxRadius, Color, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React, { useEffect } from 'react';

import { OperationType } from '../../../../../../../../../components/OperationType';
import { TableContentItemText } from '../../../../../../../../../components/TableContent';
import { useDirectTreasurySellAssetController } from '../../../../../hooks/products/DirectTreasurySell';
import { LateralBar } from '../../../components/LateralBar';

import { DirectTreasuryItemSelectedTypes, directTreasuryRescueNoticeMessage } from '.';

export const DirectTreasuryItemSelectedTablet: React.FC<DirectTreasuryItemSelectedTypes.Props> = ({
  offer,
  onUpdate,
}) => {
  const id = offer.titleId;
  const { amountItem, amountValue, amountValueFormatted, handleChangeAmountItem } =
    useDirectTreasurySellAssetController(offer);

  useEffect(() => {
    if (offer.orderQuantity === amountItem || !amountItem) {
      return;
    }
    const updatedOffer = {
      ...offer,
      orderQuantity: amountItem || 0.01,
      orderValue: amountValue,
    };
    onUpdate(updatedOffer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [amountItem]);

  return (
    <UI.List testId="selected-product" height="container">
      <LateralBar
        backgroundColor={Color['product.tesouro']}
        borderTopLeftRadius={BoxRadius.sm}
        borderBottomLeftRadius={BoxRadius.sm}
      />
      <VStack flex={1} space="stack.xxxs">
        <UI.Notice
          key="notice-direct-treasury-rescue"
          backgroundColor={Utils.ColorToken.WithOpacity('feedback.attention.lightest', 0.4)}
          textObjects={directTreasuryRescueNoticeMessage}
        />
        <HStack flex={1} justifyContent="space-between">
          <UI.ListItem testId="selected-product-name" title="Produto" stackProps={{ maxW: '1/6' }}>
            <TableContentItemText tooltip={offer.productNameNormalized}>
              {offer.productNameNormalized}
            </TableContentItemText>
          </UI.ListItem>
          <UI.ListItem testId="selected-product-type" title="Tipo">
            <OperationType title="Resgate" />
          </UI.ListItem>
          <UI.ListItem testId="selected-product-available-quantity" title="Quantidade disponível">
            <TableContentItemText>{offer.quantityAvailableFormatted}</TableContentItemText>
          </UI.ListItem>
          <UI.ListItem testId="selected-product-amount" title="Valor estimado">
            <TableContentItemText>{amountValueFormatted}</TableContentItemText>
          </UI.ListItem>
          <UI.ListItem testId="selected-product-available-in" title="Disponível em conta">
            <TableContentItemText>
              {offer.redemptionDate
                ? Utils.Mask.DateFormat(offer.redemptionDate, 'dd/MM/yyyy')
                : '--'}
            </TableContentItemText>
          </UI.ListItem>
        </HStack>
        <HStack flex={1} flexGrow={1}>
          <UI.ListItem
            testId="selected-product-name"
            title="Quantidade"
            stackProps={{ flexGrow: 1 }}>
            <Stack w="full">
              <UI.InputStepper
                stepperValue={0.01}
                max={offer.availableQuantity}
                min={offer.minimumStepQuantity || 0}
                name={`treasury-amount-order-input-${id}`}
                keyboardType="numeric"
                fontSize={Typography['fontsize.md']}
                defaultValue={amountItem || 0}
                onChange={handleChangeAmountItem}
                showErrorMessage={false}
              />
            </Stack>
          </UI.ListItem>
        </HStack>
      </VStack>
    </UI.List>
  );
};
